import { Component, inject, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../../../core/services/theme.service';

@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './theme-toggle.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ThemeToggleComponent {
  protected themeService = inject(ThemeService);
}
